import { Button } from "react-bootstrap";
import { BinIcon } from "../../../../components/icon/Icon";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

export const OnboardingTutorialButton = ({children, disabled, onClick}) => {
    const {getLangPath} = useLangContext();
    return (
            <Button
                    disabled={disabled}
                    size="lg"
                    variant="link"
                    onClick={onClick}
            >
                <div className="d-flex align-items-center justify-content-center">
                    {children || <span>{getLangPath('onboarding.next')}</span>}
                    <BinIcon className="ms-2" name="IcArrowRight" style={{fill: 'var(--color-yellow)'}}/>
                </div>
            </Button>
    );
}
